import { BehaviorSubject, Observable, merge } from "rxjs";
import { FlatTreeControl } from "@angular/cdk/tree";
import { CollectionViewer, SelectionChange } from "@angular/cdk/collections";
import { map } from 'rxjs/operators';
import { JsonHierarchyElement } from "@psnb/nwt-api";
import { HierarchyNodeList } from "../models/hierarchy-node-List";
import { GetSystemHierarchyService } from "./get-system-hierarchy.service";

export class SystemHierarchyDataSourceService {

  dataChange: BehaviorSubject<HierarchyNodeList[]> = new BehaviorSubject<HierarchyNodeList[]>([]);
  children: Observable<JsonHierarchyElement[]>;

  get data(): HierarchyNodeList[] { return this.dataChange.value; }
  set data(value: HierarchyNodeList[]) {
    this.treeControl.dataNodes = value;
    this.dataChange.next(value);
  }

  constructor(
    private treeControl: FlatTreeControl<HierarchyNodeList>,
    private getHierarchyService: GetSystemHierarchyService
  ) { }

  connect(collectionViewer: CollectionViewer): Observable<HierarchyNodeList[]> {
    this.treeControl.expansionModel.changed!.subscribe(change => {
      if ((change as SelectionChange<HierarchyNodeList>).added ||
        (change as SelectionChange<HierarchyNodeList>).removed) {
        this.handleTreeControl(change as SelectionChange<HierarchyNodeList>);
      }
    });
    return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
  }

  /** Handle expand/collapse behaviors */
  handleTreeControl(change: SelectionChange<HierarchyNodeList>) {
    if (change.added) {
      change.added.forEach((node) => this.toggleNode(node, true));
    }
    if (change.removed) {
      change.removed.slice().reverse().forEach((node) => this.toggleNode(node, false));
    }
  }

  /**
 * Toggle the node, remove from display list
 */
  toggleNode(node: HierarchyNodeList, expand: boolean) {
    node.isLoading = true;
    this.children = this.getHierarchyService.getChildren(node.item);
    this.children
      .subscribe(child => {
        const index = this.data.indexOf(node);
        if (!child || index < 0) {
          return;
        }

        setTimeout(() => {
          if (expand) {
            const nodes = child.map(name =>
              new HierarchyNodeList(name, node.level + 1, this.getHierarchyService.isExpandable(name), false));
            this.data.splice(index + 1, 0, ...nodes);
          } else {
            let count = 0;
            for (let i = index + 1; i < this.data.length
              && this.data[i].level > node.level; i++ , count++) { }
            this.data.splice(index + 1, count);
          }

          // notify the change
          this.dataChange.next(this.data);
          node.isLoading = false;
        }, 100);
      },
        err => {
          console.log(err);
        }
      );
  }
}
